import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import initializeSentry from 'components/SentrySetup';
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import './i18n/i18next';

initializeSentry();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register({
  autoUpdate: true,
  onUpdate: (registration) => {
    const onSwUpdate = new CustomEvent('onSwUpdate', { detail: registration });
    window.dispatchEvent(onSwUpdate);
  },
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
